export const OnlineLockLevel = 3